import AircraftBoat from './components/Icon/AircraftBoat.vue'
import Alarm from './components/Icon/Alarm.vue'
import Archive from './components/Icon/Archive.vue'
import ArrowDown from './components/Icon/ArrowDown.vue'
import ArrowDownRight from './components/Icon/ArrowDownRight.vue'
import ArrowLeft from './components/Icon/ArrowLeft.vue'
import ArrowLeftRight from './components/Icon/ArrowLeftRight.vue'
import ArrowRight from './components/Icon/ArrowRight.vue'
import ArrowUp from './components/Icon/ArrowUp.vue'
import Article from './components/Icon/Article.vue'
import Back from './components/Icon/Back.vue'
import Boxes from './components/Icon/Boxes.vue'
import Building from './components/Icon/Building.vue'
import Buildings from './components/Icon/Buildings.vue'
import Calendar from './components/Icon/Calendar.vue'
import Chat from './components/Icon/Chat.vue'
import Check from './components/Icon/Check.vue'
import CheckWithBoxes from './components/Icon/CheckWithBoxes.vue'
import ChevronDown from './components/Icon/ChevronDown.vue'
import ChevronLeft from './components/Icon/ChevronLeft.vue'
import ChevronRight from './components/Icon/ChevronRight.vue'
import ChevronUp from './components/Icon/ChevronUp.vue'
import ClipboardUser from './components/Icon/ClipboardUser.vue'
import Clock from './components/Icon/Clock.vue'
import Cog from './components/Icon/Cog.vue'
import Comment from './components/Icon/Comment.vue'
import CommentEmpty from './components/Icon/CommentEmpty.vue'
import Copy from './components/Icon/Copy.vue'
import Delete from './components/Icon/Delete.vue'
import Document from './components/Icon/Document.vue'
import Documents from './components/Icon/Documents.vue'
import Download from './components/Icon/Download.vue'
import Edit from './components/Icon/Edit.vue'
import Editor from './components/Icon/Editor.vue'
import Eye from './components/Icon/Eye.vue'
import Feedback from './components/Icon/Feedback.vue'
import Filter from './components/Icon/Filter.vue'
import Folder from './components/Icon/Folder.vue'
import Form from './components/Icon/Form.vue'
import Fullscreen from './components/Icon/Fullscreen.vue'
import FullscreenClose from './components/Icon/FullscreenClose.vue'
import Globe from './components/Icon/Globe.vue'
import Grab from './components/Icon/Grab.vue'
import Inbox from './components/Icon/Inbox.vue'
import InfoCircle from './components/Icon/InfoCircle.vue'
import Link from './components/Icon/Link.vue'
import Mail from './components/Icon/Mail.vue'
import MenuHide from './components/Icon/MenuHide.vue'
import MenuShow from './components/Icon/MenuShow.vue'
import Minus from './components/Icon/Minus.vue'
import Organization from './components/Icon/Organization.vue'
import PaperPlane from './components/Icon/PaperPlane.vue'
import Pause from './components/Icon/Pause.vue'
import Photo from './components/Icon/Photo.vue'
import Pin from './components/Icon/Pin.vue'
import Play from './components/Icon/Play.vue'
import Plus from './components/Icon/Plus.vue'
import PlusCircle from './components/Icon/PlusCircle.vue'
import Print from './components/Icon/Print.vue'
import Projects from './components/Icon/Projects.vue'
import QuestionCircle from './components/Icon/QuestionCircle.vue'
import Refresh from './components/Icon/Refresh.vue'
import Report from './components/Icon/Report.vue'
import Search from './components/Icon/Search.vue'
import Sliders from './components/Icon/Sliders.vue'
import Stop from './components/Icon/Stop.vue'
import SuitCase from './components/Icon/SuitCase.vue'
import Support from './components/Icon/Support.vue'
import Sync from './components/Icon/Sync.vue'
import Table from './components/Icon/Table.vue'
import Tachometer from './components/Icon/Tachometer.vue'
import Tags from './components/Icon/Tags.vue'
import ThumbsDown from './components/Icon/ThumbsDown.vue'
import ThumbsUp from './components/Icon/ThumbsUp.vue'
import Undo from './components/Icon/Undo.vue'
import Upload from './components/Icon/Upload.vue'
import User from './components/Icon/User.vue'
import UserBox from './components/Icon/UserBox.vue'
import UserCircle from './components/Icon/UserCircle.vue'
import UserFriends from './components/Icon/UserFriends.vue'
import UserPolice from './components/Icon/UserPolice.vue'
import Users from './components/Icon/Users.vue'
import { type Dayjs } from './utils/day.ts'

export const V_BADGE_TYPES = ['red', 'orange', 'green', 'primary', 'secondary', 'info'] as const
export type VBadgeType = (typeof V_BADGE_TYPES)[number]

export const V_BUTTON_TYPES = ['', 'primary', 'secondary', 'tertiary', 'red', 'green', 'white', 'info', 'link', 'icon'] as const
export type VButtonType = (typeof V_BUTTON_TYPES)[number]

export const V_BUTTON_SIZES = ['mini', 'small', 'medium', 'large'] as const
export type VButtonSize = (typeof V_BUTTON_SIZES)[number]

export const V_CALENDAR_PRECISION = ['days', 'months', 'years'] as const
export type VCalendarPrecision = (typeof V_CALENDAR_PRECISION)[number]

export interface VCalendarQuickOption {
  label: string
  value: Dayjs | [Dayjs | null, Dayjs | null]
}

export const V_CARD_TYPES = ['', 'primary', 'info', 'page-background', 'green', 'yellow', 'red'] as const
export type VCardType = (typeof V_CARD_TYPES)[number]

export const V_CARD_SIZES = ['', 'small'] as const
export type VCardSize = (typeof V_CARD_SIZES)[number]

export type VCardRibbonType = 'primary' | undefined

export const V_CHECKBOX_GROUP_TYPES = ['', 'card'] as const
export type VCheckboxGroupType = (typeof V_CHECKBOX_GROUP_TYPES)[number]

export const V_DIALOG_PLACEMENTS = ['center', 'left', 'right', 'top', 'bottom', 'fullscreen'] as const
export type VDialogPlacement = (typeof V_DIALOG_PLACEMENTS)[number]

export const V_FORM_TRIGGERS = ['submit', 'keyup', 'blur'] as const
export type VFormTrigger = (typeof V_FORM_TRIGGERS)[number]

export const V_ICON_COMPONENTS = {
  AircraftBoat,
  Alarm,
  Archive,
  ArrowDown,
  ArrowDownRight,
  ArrowLeft,
  ArrowLeftRight,
  ArrowRight,
  ArrowUp,
  Article,
  Back,
  Boxes,
  Building,
  Buildings,
  Calendar,
  Chat,
  Check,
  CheckWithBoxes,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ClipboardUser,
  Clock,
  Close: Plus,
  CloseCircle: PlusCircle,
  Cog,
  Comment,
  CommentEmpty,
  Copy,
  Delete,
  Document,
  Documents,
  Download,
  Edit,
  Editor,
  Eye,
  Feedback,
  Filter,
  Folder,
  Form,
  Fullscreen,
  FullscreenClose,
  Globe,
  Grab,
  Inbox,
  InfoCircle,
  Link,
  Mail,
  MenuHide,
  MenuShow,
  Minus,
  Organization,
  PaperPlane,
  Pause,
  Photo,
  Pin,
  Play,
  Plus,
  PlusCircle,
  Print,
  Projects,
  QuestionCircle,
  Refresh,
  Report,
  Search,
  Sliders,
  Stop,
  SuitCase,
  Support,
  Sync,
  Table,
  Tachometer,
  Tags,
  ThumbsDown,
  ThumbsUp,
  Undo,
  Upload,
  User,
  UserBox,
  UserCircle,
  UserFriends,
  UserPolice,
  Users,
} as const
export const V_ICON_ICONS = Object.keys(V_ICON_COMPONENTS) as unknown as keyof typeof V_ICON_COMPONENTS
export type VIconIcon = typeof V_ICON_ICONS

export const V_ICON_TYPES = ['black', 'white', 'primary', 'secondary', 'tertiary', 'green', 'orange', 'red', 'info', 'placeholder', 'blue-1', 'blue-3', 'blue-5'] as const
export type VIconType = (typeof V_ICON_TYPES)[number]

export const V_INPUT_SIZES = ['small', 'medium', 'large'] as const
export type VInputSize = (typeof V_INPUT_SIZES)[number]

export const V_INPUT_STATUSES = ['', 'error', 'success'] as const
export type VInputStatus = (typeof V_INPUT_STATUSES)[number]

export const V_INPUT_TYPES = ['text', 'number', 'tel', 'email', 'password'] as const
export type VInputType = (typeof V_INPUT_TYPES)[number]

export const V_LOADING_BAR_PLACEMENTS = ['', 'bottom', 'top'] as const
export type VLoadingBarPlacement = (typeof V_LOADING_BAR_PLACEMENTS)[number]

export const V_NOTIFICATION_PLACEMENTS = ['', 'top', 'top-right', 'top-left', 'bottom-left', 'bottom-right'] as const
export type VNotificationPlacement = (typeof V_NOTIFICATION_PLACEMENTS)[number]

export const V_NOTIFICATION_TYPES = ['', 'primary', 'info', 'success', 'dark', 'warning', 'error', 'green', 'yellow', 'red', 'purple'] as const
export type VNotificationType = (typeof V_NOTIFICATION_TYPES)[number]

export const V_PAGINATION_LAYOUTS = ['pager', 'sizes', 'arrows'] as const
export type VPaginationLayout = (typeof V_PAGINATION_LAYOUTS)[number]

export const V_POPPER_PLACEMENTS = [
  'top-start',
  'top',
  'top-end',
  'right-start',
  'right',
  'right-end',
  'bottom-start',
  'bottom',
  'bottom-end',
  'left-start',
  'left',
  'left-end',
] as const
export type VPopperPlacement = (typeof V_POPPER_PLACEMENTS)[number]

export const V_POPPER_TRIGGERS = ['hover', 'focus', 'click', 'manual', 'disabled'] as const
export type VPopperTrigger = (typeof V_POPPER_TRIGGERS)[number]

export const V_PROGRESS_TYPES = ['primary', 'secondary', 'green', 'green-light', 'yellow', 'orange', 'red', 'blue-5', 'dark', 'white'] as const
export type VProgressType = (typeof V_PROGRESS_TYPES)[number]

export const V_RADIO_TYPES = ['', 'vertical', 'tabs', 'tabs-bordered', 'tabs-bordered-primary', 'card', 'toggle'] as const
export type VRadioType = (typeof V_RADIO_TYPES)[number]

export const V_SORT_CARETS_OPTIONS = ['', 'asc', 'desc'] as const
export type VSortCaretOption = (typeof V_SORT_CARETS_OPTIONS)[number]

export const V_STEP_TYPES = ['black', 'white', 'red', 'orange', 'green'] as const
export type VStepType = (typeof V_STEP_TYPES)[number]

export const V_TAG_SIZES = ['mini', 'small', 'medium', 'large'] as const
export type VTagSize = (typeof V_TAG_SIZES)[number]

export const V_TAG_TYPES = ['primary', 'secondary', 'blue-3', 'blue-5', 'info', 'red-dark', 'red', 'orange', 'green-dark', 'green', ''] as const
export type VTagType = (typeof V_TAG_TYPES)[number]

export const V_TEXTAREA_RESIZE_OPTIONS = ['none', 'both', 'horizontal', 'vertical', 'inherit'] as const
export type VTextareaResizeOption = (typeof V_TEXTAREA_RESIZE_OPTIONS)[number]

export const V_TOOLTIP_TYPES = ['dark', 'light'] as const
export type VTooltipType = (typeof V_TOOLTIP_TYPES)[number]

export type SortOrder = 'asc' | 'desc' | ''

export interface FileLike {
  name: string
  size?: number
  type?: string
  loading?: boolean
}

/**
 * This allows for autocompletion on literal strings when combined with literal strings.
 * A normal 'foo' | string does not work. But 'foo' | SomeOtherString works.
 */
export type SomeOtherString = string & Record<never, never>

/**
 * Allows for simpler typing of values that can optionally be an array.
 */
export type MaybeArray<T> = T | T[]

/**
 * Allows for simpler typing of values that can optionally be a promise.
 * @example
 * // Before
 * boolean | string | Promise<boolean | string>
 * // After
 * MaybePromise<boolean | string>
 */
export type MaybePromise<T> = T | Promise<T>

/**
 * Construct a type which is a subset of `T`, containing at least all attributes of union `K`.
 * @example
 * // Correct:
 * const test: AtLeast<{id: number, name: string, age: number}, 'id' | 'name'> = { id: 1 }
 * // Shows error:
 * const test: AtLeast<{id: number, name: string, age: number}, 'id' | 'name'> = { id: 1, new: true }
 * const test: AtLeast<{id: number, name: string, age: number}, 'id' | 'name'> = { age: 1 }
 */
export type AtLeast<T, K extends keyof T> = Partial<T> & Pick<T, K>

/**
 * Construct a type which is a subset of `T`, where all attributes of `K` are optional.
 */
export type PartialBy<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>

/**
 * Construct a type which extends`T` with overwritten properties defined in `U`.
 * @example
 * type NameIsRequired = Overwrite<{id: number; name: string | null }, { name: string }>
 */
export type Overwrite<T, U> = Pick<T, Exclude<keyof T, keyof U>> & U

export type WithRequired<T, K extends keyof T> = T & { [P in K]-?: T[P] }
